import { imageAlt } from './ImageStore';

export const updateImageAlt = (value) => imageAlt.update((oldValue) => value);
